import React from "react";
import transact from "../../assets/imgs/transactionCompleted2.svg"

const TransactionCompleted = () => {
  return (
<div style={{
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh', 
}}>
  <div>
    <img 
      src={transact} 
      alt="Transaction Icon"
      style={{
        maxWidth: '100%', 
        height: 'auto',  
      }} 
    />
  </div>
</div>

  );
};

export default TransactionCompleted;
